import { ReactElement } from "react";
import { resolveProperty } from "@animech/axiom-utility";
import {
	FieldComponentBuilderArgs,
	FieldPipe,
	FieldPipeMeta,
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";
import { ColorPickerField } from "../components/widgets/color-picker";
import { Root } from "@definitions";
import { ColorPickerNode } from "src/definitions/ui-definitions";

type ComponentBuilderArgs = FieldComponentBuilderArgs<Root, ColorPickerNode>;

export class ColorPickerComponentBuilder
	implements UiComponentBuilder<Root, ColorPickerNode>
{
	private _args: ComponentBuilderArgs;

	constructor(args: ComponentBuilderArgs) {
		this._args = { ...args };
	}

	public build(node: ColorPickerNode, context: UiComponentBuildContext<Root>) {
		const { getFieldNodeMeta, getFieldNodeValueMeta } = this._args;

		if (node.state) {
			const property = resolveProperty(node.state, context.activeProperty);
			return (
				<FieldPipe
					key={`${node.id}:${context.activeProperty}`}
					property={property}
					write
				>
					<FieldPipeMeta
						getFieldMeta={(property) => getFieldNodeMeta(node, property)}
						getFieldValueMeta={getFieldNodeValueMeta}
					>
						{this._render(node, context)}
					</FieldPipeMeta>
				</FieldPipe>
			);
		} else {
			return this._render(node, context);
		}
	}

	private _render(
		_node: ColorPickerNode,
		_context: UiComponentBuildContext<Root>,
	): ReactElement {
		return <ColorPickerField />;
	}
}
